import store from "@frameworks/web/redux/store";
import { NEW_ON_EDEL_DATA, NEW_ON_EDEL_START_LOADER, NEW_ON_EDEL_STOP_LOADER, NEW_ON_EDEL_SET_ERROR, NEW_ON_EDEL_HIDE_ERROR, } from "../../interfaces/Home/iNewOnEdel";
class NewOnEdelActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getNewOnEdel(data) {
        this.dispatch({
            type: NEW_ON_EDEL_DATA,
            payload: { data },
        });
    }
    startLoader() {
        this.dispatch({
            type: NEW_ON_EDEL_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: NEW_ON_EDEL_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: NEW_ON_EDEL_SET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: NEW_ON_EDEL_HIDE_ERROR,
        });
    }
}
export default NewOnEdelActions;
